import React from "react";
import { makeStyles } from "@material-ui/core";
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/CloseOutlined";
import { Slide } from "@material-ui/core";
import { ReactComponent as AlertIcon } from "../../../../icons/alert.svg";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  input: {},
  root: {
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#158380"
    }
  },
  alertMsg: {
    color: "red"
  },
  MuiBackdrop: {
    backgroundColor: "rgba(0,0,0,0.6)"
  }
}));

export default function DeletePage(props) {
  const classes = useStyles();

  const cancel = () => {
    props.onHide("cancel");
  };
  const continueDelete = () => {
    props.onHide("continue");
  };
  const okDelete = () => {
    props.onHide("ok");
  };

  return (
    <div>
      <Dialog
        PaperProps={{}}
        className={classes.MuiBackdrop + " popupstyle"}
        disableBackdropClick
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        maxWidth="sm"
        open={props.show}
        onClose={cancel}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <div className="dialogTitle">
          <DialogTitle id="scroll-dialog-title">
            <span className="dialogtitle">{props.headertxt}</span>
          </DialogTitle>
          <IconButton onClick={cancel} aria-label="close" className="closebtn">
            <CloseIcon />
            close
          </IconButton>
        </div>
        <div className="alert-text">
          <AlertIcon />
          <p>Alert</p>
        </div>
        <DialogContent className="delete-text">
          <DialogContentText
            component="div"
            id="scroll-dialog-description"
            tabIndex={-1}
          >
            {props.loading ? (
              <span className="ml-3 spinner spinner-dark"></span>
            ) : (
              <p>{props.deleteMsg}</p>
            )}
            <p className="error">{props.haserror}</p>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          {props.toshowokbtn === true || props.haserror ? (
            <button
              className="cancelButton btn btn shadow-btn "
              onClick={okDelete}
            >
              Ok
            </button>
          ) : (
            <div>
              <button
                className="cancelButton btn btn shadow-btn "
                disabled={props.loading ? true : false}
                onClick={cancel}
              >
                Cancel
              </button>
              <button
                className="saveButton continue"
                disabled={props.loading ? true : false}
                onClick={continueDelete}
              >
                Continue
                {props.loading ? (
                  <span className="ml-3 spinner spinner-light"></span>
                ) : null}
              </button>
            </div>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
